<div class="container-fluid" style="padding-top: 20px">
  <div class="row">
    <div class="col-xs-12">
      <h2>Admin Panel</h2>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Users">
      <div style="margin-top: 20px">
        <div class="row">
          <div class="col-xs-12">
            <button
              mat-raised-button
              color="primary"
              (click)="openCreateUserModal()">
              Create New User
            </button>
          </div>
        </div>
        <br />

        <div class="row">
          <div class="col-xs-12">
            <mat-form-field appearance="standard">
              <mat-label>Filter</mat-label>
              <input
                matInput
                (keyup)="applyFilter($event)"
                placeholder="Ex. Mia"
                #input />
            </mat-form-field>

            <div class="mat-elevation-z8">
              <table mat-table [dataSource]="dataSource" matSort>
                <!-- Username Column -->
                <ng-container matColumnDef="username">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Username
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.username }}</td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="name">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Name
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.name }}</td>
                </ng-container>

                <!-- Email Column -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Email
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.email }}</td>
                </ng-container>

                <!-- Role Column -->
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Role
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.role }}</td>
                </ng-container>

                <!-- Status Column -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Status
                  </th>
                  <td mat-cell *matCellDef="let row">{{ row.status }}</td>
                </ng-container>

                <!-- Price Erect Column -->
                <ng-container matColumnDef="pricePerBoardErect">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Price Erect
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.pricePerBoardErect }}
                  </td>
                </ng-container>

                <!-- Price Change Column -->
                <ng-container matColumnDef="pricePerBoardChange">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    Price Change
                  </th>
                  <td mat-cell *matCellDef="let row">
                    {{ row.pricePerBoardChange }}
                  </td>
                </ng-container>

                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef>Actions</th>
                  <td mat-cell *matCellDef="let row">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      aria-label="Example icon-button with a menu">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button mat-menu-item (click)="openEditUserModal(row)">
                        <mat-icon>edit</mat-icon>
                        <span>Edit</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="openChangePasswordModal(row)">
                        <mat-icon>vpn_key</mat-icon>
                        <span>Change Password</span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">
                    No data matching the filter "{{ input.value }}"
                  </td>
                </tr>
              </table>

              <mat-paginator
                [pageSizeOptions]="[5, 10, 25, 100]"
                aria-label="Select page of users"></mat-paginator>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Monthly Board Actions">
      <app-board-action-summary></app-board-action-summary>
    </mat-tab>
  </mat-tab-group>
</div>
